export const ACTION_SET_MOBILE_CONNECTION_DATA = "SET_MOBILE_CONNECTION_DATA";
